/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */
/* eslint-disable conversations/no-dynamic-i18n */

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import DashedLabel from 'conversations-inbox-message-history/atoms/DashedLabel';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { agentTypeToSenderType } from 'conversations-message-history/senders/operators/agentTypeToSenderType';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getId, getEmail, getFirstName, getLastName } from 'conversations-message-history/senders/operators/getters';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import { getCurrentThreadInboxId } from '../../thread-details/selectors/getCurrentThreadInboxId';
import { getAuditAgentId, getAuditAgentType, getDestinationInbox
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
} from 'conversations-message-history/inbox-update-message/operators/inboxUpdateMessageGetters';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getVerboseDateText } from 'conversations-message-history/util/getVerboseDateText';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import formatName from 'I18n/utils/formatName';
import { fetchInboxName } from 'conversations-thread-data/move-to-inbox/public/clients';
import { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const chooseInboxChangeMessage = ({
  activeAgentId,
  auditAgentSender,
  auditAgentName,
  currentInboxId,
  destinationInboxId,
  destinationInboxName,
  date
}) => {
  const activeAgentIsMover = auditAgentSender && activeAgentId === getId(auditAgentSender);
  const currentInboxIsDestination = currentInboxId === destinationInboxId;
  const inboxTranslationKey = destinationInboxName ? 'namedInbox' : 'anotherInbox';
  if (activeAgentIsMover) {
    // you moved this message
    if (currentInboxIsDestination) {
      // you moved this message to this inbox
      return {
        i18nKey: 'conversations-thread-view.move-to-inbox.activeAgentMover.currentInbox',
        options: {
          date
        }
      };
    } else {
      // you moved this conversation to another inbox
      return {
        i18nKey: `conversations-thread-view.move-to-inbox.activeAgentMover.${inboxTranslationKey}`,
        options: {
          date,
          destinationInboxName
        }
      };
    }
  } else if (auditAgentName) {
    // some agent moved this conversations
    if (currentInboxIsDestination) {
      // some agent moved this conversation to this inbox
      return {
        i18nKey: 'conversations-thread-view.move-to-inbox.auditAgentSender.currentInbox',
        options: {
          date,
          auditAgentName
        }
      };
    } else {
      // some agent moved this conversation to another inbox
      return {
        i18nKey: `conversations-thread-view.move-to-inbox.auditAgentSender.${inboxTranslationKey}`,
        options: {
          date,
          auditAgentName,
          destinationInboxName
        }
      };
    }
  } else {
    // unknown agent moved this conversations
    if (currentInboxIsDestination) {
      // this conversation was moved to the current inbox
      return {
        i18nKey: 'conversations-thread-view.move-to-inbox.unknownAgentSender.currentInbox',
        options: {
          date
        }
      };
    } else {
      // this conversation was moved to another inbox
      return {
        i18nKey: `conversations-thread-view.move-to-inbox.unknownAgentSender.${inboxTranslationKey}`,
        options: {
          date,
          destinationInboxName
        }
      };
    }
  }
};
const ThreadInboxUpdateMessage = ({
  message,
  senders,
  userId
}) => {
  const currentInboxId = useSelector(getCurrentThreadInboxId);
  const destinationInboxId = getDestinationInbox(message);
  const [destinationInboxName, setDestinationInboxName] = useState();
  useEffect(() => {
    if (currentInboxId !== destinationInboxId) {
      fetchInboxName(destinationInboxId).then(name => setDestinationInboxName(name)).catch(() => setDestinationInboxName(undefined));
    }
  }, [currentInboxId, destinationInboxId]);
  const auditAgentId = getAuditAgentId(message);
  const auditAgentType = agentTypeToSenderType(getAuditAgentType(message));
  const auditAsyncSender = findSender(auditAgentId, auditAgentType, senders);
  const isLoading = isSenderLoading(auditAsyncSender);
  const auditAgentSender = auditAsyncSender && getData(auditAsyncSender);
  const auditAgentName = formatName({
    firstName: auditAgentSender && getFirstName(auditAgentSender),
    lastName: auditAgentSender && getLastName(auditAgentSender),
    email: auditAgentSender && getEmail(auditAgentSender)
  });
  const timestamp = getTimestamp(message);
  const date = getVerboseDateText(timestamp);
  if (isLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      width: 200,
      use: "on-shade"
    });
  }
  const {
    i18nKey,
    options
  } = chooseInboxChangeMessage({
    activeAgentId: userId,
    auditAgentSender,
    auditAgentName,
    currentInboxId,
    destinationInboxId,
    destinationInboxName,
    date
  });
  return /*#__PURE__*/_jsx(DashedLabel, {
    transparent: true,
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: i18nKey,
      options: options
    })
  });
};
const propTypes = {
  message: RecordPropType('InboxUpdateMessage').isRequired,
  senders: SenderMap,
  userId: PropTypes.number.isRequired
};
ThreadInboxUpdateMessage.propTypes = propTypes;
export default ThreadInboxUpdateMessage;